import React, { FunctionComponent, useState } from 'react'
import { connect } from 'react-redux'
import LoadingSection from '../../../components/loadingSection'
import { selectProductPackageLoading } from '../../../reducers/productPackages'

import { updateProductPackage } from '../productPackageActions'
import {
  coverageDetailsNextStep,
  openProfileSection,
} from '../refiActions'
import {
  selectCoverageProducts,
  selectCurrentPackageProducts,
  selectCurrentProductPackageId,
  selectCurrentRefiUser,
} from '../../../reducers/refis'
import { Callback } from '../../../utils/types'
import { Product } from '../../refiTransactions/types'
import ProductsForm from '../productsForm'

interface Props {
  products: Product[]
  coverageDetailsNextStep: Callback
  openProfileSection: Callback
  updateProductPackage: Callback<Promise<any>>
  selectedCoverageProducts: { selectedOptions: []; selectedSurcharges: [] }
  productPackageId: number
  userId: number
  isCreatingPackage: boolean
}

export const CoverageProtectionSection: FunctionComponent<Props> = ({
  products,
  coverageDetailsNextStep,
  openProfileSection,
  updateProductPackage,
  selectedCoverageProducts,
  productPackageId,
  userId,
  isCreatingPackage,
}) => {
  const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false)

  const handleSubmit = ({
    isDeclineCoverage,
    filters,
    addons,
    options,
    discount,
    autosaveMode,
  }) => {
    setIsSubmitBtnLoading(true)
    let updateRequest

    if (isDeclineCoverage) {
      // console.log('call api to DeclineCoverage')
      //call api to DeclineCoverage: TO DO
    } else {
      updateRequest = updateProductPackage({
        user_id: userId,
        id: productPackageId,
        surcharges: selectedCoverageProducts.selectedSurcharges,
        filters,
        options,
        addons,
        discount,
      })
      //TO DO: Validate what is wrong on form
    }

    if (autosaveMode) {
      Promise.resolve(updateRequest).finally(() => setIsSubmitBtnLoading(false))
      return
    }

    coverageDetailsNextStep()
  }

  return (
    <div className="coverage__margin-top">
      <div className="coverage__sub-header coverage__sub-header--margin-bottom">
        Compare coverage/protection
      </div>
      <LoadingSection isLoading={isCreatingPackage}>
        <ProductsForm
          products={products}
          onClickBack={openProfileSection}
          onSubmit={handleSubmit}
          selectedCoverageProducts={selectedCoverageProducts}
          submitButtonText="Save and Continue"
          isSubmitBtnLoading={isSubmitBtnLoading}
        />
      </LoadingSection>
    </div>
  )
}

export const mapStateToProps = (state) => ({
  products: selectCurrentPackageProducts(state),
  selectedCoverageProducts: selectCoverageProducts(state),
  productPackageId: selectCurrentProductPackageId(state),
  userId: selectCurrentRefiUser(state).id,
  isCreatingPackage: selectProductPackageLoading(state),
})

export default connect(mapStateToProps, {
  updateProductPackage,
  coverageDetailsNextStep,
  openProfileSection,
})(CoverageProtectionSection)
